<template>
  <div class="pa-0 svg-b-1">
    <v-form>
      <v-container class="pa-0 svg-b-1" style="height: 100vh" fluid fill-height>
        <v-row align="center">
          <v-col cols="12" sm="0" md="5" :class="[$vuetify.breakpoint.smAndDown ? 'd-none' : 'd-block']">
            <v-img
              class="mt-n3"
              height="100vh"
              src="https://images.unsplash.com/photo-1530575786986-06744b3d4073?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80"
            >
            </v-img>
          </v-col>
          <v-col cols="12" md="7">
            <v-card
              shaped
              elevation="10"
              style="max-width: 450px"
              class="mx-auto justify-center px-5 py-12"
            >
              <div align="center">
                <v-img
                  width="20%"
                  contain
                  class="ml-0 mb-8"
                  src="@/assets/favicon.png"
                ></v-img>
              </div>
              <h2 class="primary--text pt-4 pb-6 text-center">Log In</h2>
              <v-subheader style="display: block !important" class="text-center mt-n2">Fill the fields to log in</v-subheader>
              <div>
                <v-text-field
                  v-model="email"
                  id="email"
                  name="email"
                  prepend-inner-icon="mdi-email"
                  rounded
                  outlined
                  label="E-mail"
                  :rules="emailRules"
                ></v-text-field>
              </div>
              <div>
                <v-text-field
                  v-model="password"
                  id="password"
                  name="password"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  :type="show ?'text' : 'password'"
                  rounded
                  outlined
                  label="Password"
                  @keydown.enter.prevent="doLogin"
                ></v-text-field>
              <transition name="shake">
                  <p class="red--text text-center shake mt-n2" v-if="err">{{err}}</p> 
              </transition>
              </div>
              <div align="center">
                <v-btn rounded class="accent" block @click="doLogin" :disabled="email === '' || password === ''">Log In</v-btn>
                <v-btn rounded text small color="grey--text text--lighten-1" class="mt-3" @click="recovery(email)" :disabled="email.length<5">Recover password</v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
     <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Restore password</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card>
                            <v-card-title>Enter data</v-card-title>
                            <v-card-text class="pb-8"> 
                                <v-row>
                                    <v-col class="text-left">
                                        <v-row class="text-left mx-auto mt-3 mb-auto">Nueva contraseña</v-row>
                                        <v-text-field
                                            v-model="nwPswd.new"
                                            type="password"
                                            label="Escriba nueva contraseña"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="text-left">
                                        <v-row class="text-left mx-auto mt-3 mb-auto">Repetir contraseña</v-row>
                                        <v-text-field
                                            v-model="nwPswd.conf"
                                            type="password"
                                            label="Repita nueva contraseña"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                              </v-card-text>
                        </v-card>  
                    </v-form>  
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue-grey lighten-1"
                        dark
                        small
                        @click="close"
                        >Cancel</v-btn
                    >
                    <v-btn 
                        color="accent" 
                        small
                        @click="save"
                        >Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            showPass: false,
            err: '',
            cnt: 0,
            open: false,
            nwPswd: {
              new: '',
              conf: ''
            },
            show: false,
            emailRules: [
              v => !!v || 'E-mail is required',
              v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
        }
    },
    methods: {
        ...mapActions({ login: 'user/login', 
        recoverPassword:'user/recoverPassword', 
        resetMeters: 'meters/resetMeters'}),
        async doLogin() {
            this.err = ''
            try {
                await this.login({
                    email: this.email,
                    password: this.password,
                })
                this.$router.push({ name: 'Main' })
            } catch (error) {
                this.cnt += 1
                if (this.cnt <= 2) this.err = 'Check data'
                else this.err = 'Forgot password? Click on button to recover it'           
            }
            console.clear()
        },
        async recovery(email){
          await this.recoverPassword(email)
        },
        close(){
          this.open = false
        },
        save(){
          console.log(this.nwPswd.new, this.nwPswd.conf)
        }
    },
}
</script>

<style>
.login {
    height: 100%;
}
.card {
    overflow: hidden !important;
}
.image-login {
    min-height: 30px;
}
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
.svg-b-1 {
    background-color: #E6E6E6;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='232' height='232' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%23023243' stroke-width='1'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%2306d676'%3E%3Ccircle cx='769' cy='229' r='4'/%3E%3Ccircle cx='539' cy='269' r='4'/%3E%3Ccircle cx='603' cy='493' r='4'/%3E%3Ccircle cx='731' cy='737' r='4'/%3E%3Ccircle cx='520' cy='660' r='4'/%3E%3Ccircle cx='309' cy='538' r='4'/%3E%3Ccircle cx='295' cy='764' r='4'/%3E%3Ccircle cx='40' cy='599' r='4'/%3E%3Ccircle cx='102' cy='382' r='4'/%3E%3Ccircle cx='127' cy='80' r='4'/%3E%3Ccircle cx='370' cy='105' r='4'/%3E%3Ccircle cx='578' cy='42' r='4'/%3E%3Ccircle cx='237' cy='261' r='4'/%3E%3Ccircle cx='390' cy='382' r='4'/%3E%3C/g%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
}
</style>